import { render } from "./UserDropdownMenu.vue?vue&type=template&id=27bf805a"
import script from "./UserDropdownMenu.vue?vue&type=script&lang=js"
export * from "./UserDropdownMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__